<template>
  <div class="divider_area"></div>
</template>

<script>
export default {
  name: 'TabbarTop',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .divider_area {
    margin-bottom: 120px;
  }
</style>
